/**Event creation functionality is there in this component */

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateEventForm.css";
import Modal from "react-bootstrap/Modal";
import {
  getThemeURL,
  getTaskConfigsURL,
  getAllEventType,
  createEvent,
  editEventInprogress,
  editEventClosed,
  getUsersFromAppByRole,
  usersByDepartment,
  departmentslist
} from "../../../../Services/EndPoints";
import {
  postDataWithBody,
  getData,
  postDataWithFiles,
} from "../../../../Services/Services";
import LocationAutoComplete from "./LocationAutoComplete";
import { XCircleblack } from "../../../../Components/IconComponents";
import {
  validateActionTaken,
  validateAssignTo,
  validateEventName,
  validateEventType,
  validateRootCause,
  validateSeverityLevel,
  validateslaTarget,
  validateSourceSystem,
  validateUser,
  validationEndDate,
  validationStartDate,
} from "./eventValidations";

const CreateEventForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  let data = state?.data;
  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userId, setUserId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [incidentCategories, setIncidentCategories] = useState([]);
  const [eventType, setEventType] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userserProfile, setUserProfile] = useState([]);
  const incidentData = state?.incidentData || {};
  const eventData = data;
  let editEvent = state?.edit;
  let newIncidentCategoryIdUpdated = data?.incidentCategoryId || 0;
  console.log(incidentData, "incidentssssssssssssss")
  // Map related states
  const [showMapModal, setShowMapModal] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [coordinates, setCoordinates] = useState([
    {
      y: 85.562, // default longitude
      x: 25.747, // default latitude
    },
  ]);
  const [mapCenterCoordinates, setMapCenterCoordinates] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(8);
  const [mapKey, setMapKey] = useState(0);
  const [incidentCategoryName, setIncidentCategoryName] = useState("");
  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({
    incidentName: "",
    eventName: "",
    eventType: "",
    sourceSystem: "",
    severity: "",
    assignTo: "",
    eventDescription: "",
    actionTaken: "",
    uploadImages: "",
    slaTarget: "",
    rootCause: "",
    actionTaken: "",
    resolutionStartDate: "",
    resolutionEndDate: "",
  });
  // Form data state
  const [formData, setFormData] = useState({
    incidentName: "",
    eventName: "",
    eventType: "",
    sourceSystem: "",
    severity: "",
    assignTo: "",
    eventDescription: "",
    actionTaken: "",
    rootCause: "",
    uploadImages: "",
    slaTarget: "",
    resolutionStartDate: "",
    resolutionEndDate: "",
  });

  useEffect(() => {
    // This will run whenever formData.status changes
    if (formData.status === "Closed") {
      setFormData((prevData) => ({
        ...prevData,
        actionTaken: "",
        resolutionStartDate: "",
      }));
    }
  }, [formData.status]);

  //Set Validation Errors
  useEffect(() => {
    setValidationErrors(prev => ({
      ...prev,
      resolutionStartDate: "",
      resolutionEndDate: "",
      rootCause: "",
      actionTaken: ""
    }));
  }, [formData.status]);

  useEffect(() => {
    if (roleList.length === 1 && filteredUsers.length === 0) {
      // If there's only one role and no users loaded yet, fetch its users
      getUsersByRole(roleList[0].value);
    }
  }, [roleList]);

  const handleEventTypeChange = (e) => {
    const selectedEventTypeValue = e.target.value;
    setFormData({ ...formData, eventType: selectedEventTypeValue });
    setValidationErrors({
      ...validationErrors,
      eventType: "",
    });
    const selectedEventType = eventType.find(
      (type) => type.value === selectedEventTypeValue
    );
    if (selectedEventType) {
      setIncidentCategoryName(selectedEventType.value);
      localStorage.setItem("incidentCategoryId", selectedEventType.id);
      localStorage.setItem("incidentCategoryName", selectedEventType.value);
      console.log(
        `Saved incident category: ${selectedEventType.id} - ${selectedEventType.value} to session storage`
      );
    }
  };
  // Handle category ID from localStorage 
  useEffect(() => {
    const savedCategoryId = localStorage.getItem("incidentCategoryId");
    const savedCategoryName = localStorage.getItem("incidentCategoryName");

    if (editEvent && newIncidentCategoryIdUpdated && savedCategoryId) {
      if (
        parseInt(newIncidentCategoryIdUpdated) === parseInt(savedCategoryId)
      ) {
        setFormData((prevData) => ({
          ...prevData,
          eventType: savedCategoryName || "",
        }));
        setIncidentCategoryName(savedCategoryName || "");
        console.log(
          `Matched incident category ID: ${savedCategoryId} with name: ${savedCategoryName}`
        );
      } else {
        const matchingEventType = eventType.find(
          (type) => type.id === parseInt(newIncidentCategoryIdUpdated)
        );
        if (matchingEventType) {
          setFormData((prevData) => ({
            ...prevData,
            eventType: matchingEventType.value,
          }));
          setIncidentCategoryName(matchingEventType.value);
          localStorage.setItem("incidentCategoryId", matchingEventType.id);
          localStorage.setItem("incidentCategoryName", matchingEventType.value);
          console.log(
            `Updated to incident category: ${matchingEventType.id} - ${matchingEventType.value}`
          );
        }
      }
    }

    // Handle form data population from data object (second useEffect logic)
    if (data) {
      console.log("Processing event data for edit mode:", data);

      // Extract data from eventIncidentMapEntity
      const rootCause = data.eventIncidentMapEntity?.rootCause || "";
      const actionTaken =
        data.eventIncidentMapEntity?.actionTakenInProgress || "";

      console.log("Root Cause:", rootCause);
      console.log("Action Taken:", actionTaken);

      // Format resolution dates if they exist
      const resolutionStartDate = data.eventIncidentMapEntity
        ?.workStartDateAndTime
        ? formatDateForInput(data.eventIncidentMapEntity.workStartDateAndTime)
        : "";

      const resolutionEndDate = data.eventIncidentMapEntity
        ?.resoultionEndDateAndTime
        ? formatDateForInput(
          data.eventIncidentMapEntity.resoultionEndDateAndTime
        )
        : "";

      console.log("Resolution Start Date:", resolutionStartDate);
      console.log("Resolution End Date:", resolutionEndDate);

      // Update formData with all values
      setFormData((prevState) => ({
        ...prevState,
        rootCause,
        actionTaken,
        resolutionStartDate,
        resolutionEndDate,
        eventName: data.eventName || prevState.eventName,
        sourceSystem: data.sourceSystem || prevState.sourceSystem,
        severity: data.severityLevel || prevState.severity,
        eventDescription: data.description || prevState.eventDescription,
      }));
    }
  }, [editEvent, newIncidentCategoryIdUpdated, eventType, data]);


  // Update form data based on status change
  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    const previousStatus = formData.status;
    let updatedFormData = { ...formData, status: newStatus };
    let updatedValidationErrors = { ...validationErrors, status: "" };

    // Handle field clearing and validation based on status transitions
    if (newStatus === "Open") {
      // Clear resolution fields when going back to Open
      updatedFormData = {
        ...updatedFormData,
        resolutionStartDate: "",
        resolutionEndDate: "",
        rootCause: "",
        actionTaken: ""
      };

      // Clear validation errors for fields that are no longer required
      updatedValidationErrors = {
        ...updatedValidationErrors,
        resolutionStartDate: "",
        resolutionEndDate: "",
        rootCause: "",
        actionTaken: ""
      };
    }
    else if (newStatus === "Closed") {
      // When changing to Closed, clear actionTaken if coming from InProgress
      if (previousStatus === "InProgress") {
        updatedFormData = {
          ...updatedFormData,
          actionTaken: "" // Clear the field as per your requirement
        };

        // Clear validation error for actionTaken since we're clearing the field
        updatedValidationErrors = {
          ...updatedValidationErrors,
          actionTaken: ""
        };
      }

      // Ensure resolutionEndDate is required for Closed status
      if (!updatedFormData.resolutionEndDate) {
        updatedValidationErrors = {
          ...updatedValidationErrors,
          resolutionEndDate: "Resolution End Date is required for Closed status"
        };
      }
    }

    // Update state with the new form data and cleared validation errors
    setFormData(updatedFormData);
    setValidationErrors(updatedValidationErrors);

    // Handle InProgress status with API call
    if (newStatus === "InProgress") {
      setIsSubmitting(true);
      setLoader(true);

      try {
        // Validate required fields for InProgress status
        const requiredFieldsForInProgress = {
          resolutionStartDate: updatedFormData.resolutionStartDate,
          rootCause: updatedFormData.rootCause,
          actionTaken: updatedFormData.actionTaken
        };

        // Check if required fields are present
        const missingFields = Object.entries(requiredFieldsForInProgress)
          .filter(([key, value]) => !value || value.trim() === "")
          .map(([key]) => key);

        if (missingFields.length > 0) {
          const newErrors = { ...updatedValidationErrors };
          missingFields.forEach(field => {
            switch (field) {
              case 'resolutionStartDate':
                newErrors.resolutionStartDate = "Resolution Start Date is required";
                break;
              case 'rootCause':
                newErrors.rootCause = "Root Cause is required";
                break;
              case 'actionTaken':
                newErrors.actionTaken = "Action Taken is required";
                break;
            }
          });

          setValidationErrors(newErrors);
          setFormData(prev => ({ ...prev, status: previousStatus }));
          return;
        }

        // Get the correct IDs from data or form data
        const eventId = data?.eventIncidentMapEntity?.eventId;
        const ID = data?.eventIncidentMapEntity?.id;
        const assignedUserId = parseInt(
          updatedFormData.selectedUser || data?.assignedToUser
        );
        const createdBy = data?.created_by ||
          data?.eventIncidentMapEntity?.created_by ||
          userId;

        // Create the JSON object that will become the value of event_map
        const eventMapValue = {
          eventId: eventId,
          id: ID,
          assignedTo: assignedUserId,
          created_by: createdBy,
          updated_by: assignedUserId,
          workStartDateAndTimeString: formatDateTime(updatedFormData.resolutionStartDate),
          rootCause: updatedFormData.rootCause || "network issue",
          actionTakenInProgress: updatedFormData.actionTaken || "checking the internet connection",
        };

        const formDataPayload = new FormData();
        formDataPayload.append("event_map", JSON.stringify(eventMapValue));
        const response = await postDataWithFiles(
          editEventInprogress,
          formDataPayload,
          {}
        );

        if (response && response.status === "success") {
          toast.success("Event status updated to In Progress", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("../event-type-details");
        } else {
          toast.error(response?.msg || "Failed to update event status", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });

          // Revert status on API failure
          setFormData(prev => ({ ...prev, status: previousStatus }));
        }
      } catch (error) {
        console.error("Error updating event status:", error);
        toast.error("An error occurred while updating event status", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });

        // Revert status on error
        setFormData(prev => ({ ...prev, status: previousStatus }));
      } finally {
        setLoader(false);
        setIsSubmitting(false);
      }
    }
  };

  //update map modal with selected lat,lngs
  const updateMapLocation = (lat, lng) => {
    setCoordinates([{ y: lng, x: lat }]);
    setFormData({
      ...formData,
      latitude: lat,
      longitude: lng,
    });
    setMapCenterCoordinates({
      y: lng,
      x: lat,
    });
    setZoomLevel(16);
    setMapKey((prevKey) => prevKey + 1);
  };


  //close map modal
  const closeMapModal = () => {
    setShowMapModal(false);
  };

  // useEffect to fetch event typee, roles for user, all roles, userprofile and incidents
  useEffect(() => {
    fetchEventType();
    fetchAllRolesforUsers();
    fetchAllRoles();
    fetchUserProfile();
    fetchIncidentDetails();
    getUserProfile();
    const savedCategoryId = localStorage.getItem("incidentCategoryId");
    const savedCategoryName = localStorage.getItem("incidentCategoryName");
    if (savedCategoryId && savedCategoryName) {
      console.log(
        `Found saved incident category: ${savedCategoryId} - ${savedCategoryName}`
      );
    }
  }, []);

  //to find the user and role
 //to find the user and role
  useEffect(() => {
    // Skip this logic if we already have users from incident data (branch users)
    if (state?.incidentData?.assignedTeam && filteredUsers.length > 0) {
      return;
    }
    
    if (
      roleList?.length > 0 &&
      userList?.length > 0 &&
      userserProfile &&
      userserProfile.created_by
    ) {
      const createdById = parseInt(userserProfile.created_by, 10);
      const matchedRole = roleList.find(
        (role) => parseInt(role.id, 10) === createdById
      );
      if (matchedRole) {
        const matchedUser = userList.find(
          (user) => parseInt(user.value, 10) === matchedRole.value
        );
        if (matchedUser) {
          setFilteredUsers([matchedUser]);
          console.log("Matched user:", matchedUser);
        } else {
          console.log("Found matching role but no matching user");
          // Only clear if we don't have incident data
          if (!state?.incidentData) {
            setFilteredUsers([]);
          }
        }
      } else {
        console.log("No matching role found for created_by:", createdById);
        // Only clear if we don't have incident data
        if (!state?.incidentData) {
          setFilteredUsers([]);
        }
      }
    }
  }, [roleList, userList, userserProfile]);

  const formatDateForInput = (dateTimeString) => {
    if (!dateTimeString) return "";
    try {
      // Handle different date formats
      let date;
      if (dateTimeString.includes(" ")) {
        // Format: "DD-MM-YYYY HH:MM AM/PM" or "YYYY-MM-DD HH:MM:SS.S"
        const [datePart, timePart] = dateTimeString.split(" ");
        // Check if date is in DD-MM-YYYY format
        if (datePart.match(/^\d{2}-\d{2}-\d{4}$/)) {
          const [day, month, year] = datePart.split("-");
          let [time, period] =
            timePart.includes("AM") || timePart.includes("PM")
              ? [timePart.split(" ")[0], timePart.split(" ")[1]]
              : [timePart, ""];
          let [hours, minutes] = time.split(":");
          // Convert 12-hour format to 24-hour format if needed
          if (period === "PM" && hours !== "12") {
            hours = parseInt(hours) + 12;
          } else if (period === "AM" && hours === "12") {
            hours = "00";
          }
          date = new Date(`${year}-${month}-${day}T${hours}:${minutes}`);
        } else {
          //YYYY-MM-DD format
          date = new Date(dateTimeString);
        }
      } else {
        // Handle ISO format
        date = new Date(dateTimeString);
      }
      // Format to local ISO string and extract just the date and time parts
      const isoString = date.toISOString();
      return isoString.substring(0, 16); // Format: YYYY-MM-DDTHH:MM
    } catch (error) {
      console.error("Error formatting date:", error, dateTimeString);
      return "";
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
    if (isSubmitting) {
      return;
    }
    // Validate the specific field
    let error = "";
    switch (id) {
      case "slaTarget":
        error = validateslaTarget(value);
        break;
      case "eventName":
        error = validateEventName(value);
        break;
      case "eventType":
        error = validateEventType(value);
        break;
      case "sourceSystem":
        error = validateSourceSystem(value);
        break;
      case "severity":
        error = validateSeverityLevel(value);
        break;
      case "assignTo":
        error = validateAssignTo(value);
        break;
      case "actionTaken":
        error = validateActionTaken(value);
        break;
      case "rootCause":
        error = validateRootCause(value);
        break;
      case "resolutionStartDate":
        error = validationStartDate(value);
        break;
      case "resolutionEndDate":
        error = validationEndDate(value);
        break;
      default:
        break;
    }
    // Update validation error for this field
    setValidationErrors(prev => ({
      ...prev,
      [id]: error,
    }));
  };

  const fetchEventType = async () => {
    if (state?.incidentData) {
      var incident = state.incidentData;
      var newIncidentCategoryId = incident.incidentCategoryId;
      console.log(newIncidentCategoryId, "newIncidentCategoryId");
    }
    try {
      let response = await getData(getAllEventType + newIncidentCategoryId);
      if (response && Array.isArray(response)) {
        setEventType(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };
  const fetchAllRolesforUsers = async () => {
  if (state?.incidentData) {
    const incident = state.incidentData;
    const assignedTeam = incident.assignedTeam;

    try {
      // Parse comma-separated string into array of numbers
      const teamIds = assignedTeam
        ? assignedTeam.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id))
        : [];
      
      console.log("Parsed team IDs:", teamIds); // Debug log
      
      // Only pre-fetch users if there's exactly ONE team
      if (teamIds.length === 1) {
        const users = await getUsersByRole(teamIds[0]);
        setFilteredUsers(users);
        setFormData(prev => ({
          ...prev,
          assignTo: teamIds[0]?.toString(),
          selectedUser: ""
        }));
      } else {
        // Multiple teams: don't pre-fetch users, let user choose team first
        setFilteredUsers([]);
        setFormData(prev => ({
          ...prev,
          assignTo: "",
          selectedUser: ""
        }));
      }
    } catch (error) {
      console.error("Error fetching initial users:", error);
    }
  }
};

  //change handler to prevent unwanted updates
  const handleRoleChange = async (e) => {
    const selectedRoleId = e.target.value;
    if (selectedRoleId !== formData.assignTo) {
      setFormData({
        ...formData,
        assignTo: selectedRoleId,
        selectedUser: "",
      });
      await getUsersByRole(selectedRoleId);
    }
  };

const getUsersByRole = async (roleId) => {
  setLoader(true);
  try {
    // Get bank_id and branch_id from incident data or user profile
    const bankId = state?.incidentData?.bankId || userserProfile?.bank_id || "";
    const branchId = state?.incidentData?.branchId || userserProfile?.branch_id || "";
    
    // Create dynamic payload
    const payload = {
      "department_id": parseInt(roleId),
      "bank_id": bankId.toString(),
      "branch_id": branchId.toString()
    };
    
    console.log("Fetching users with payload:", payload); // Debug log
    
    const response = await postDataWithBody(usersByDepartment, payload, {});
    if (response && Array.isArray(response)) {
      const users = response.map((user) => ({
        value: user.user_id,
        label: `${user.first_name} ${user.last_name}`,
        role_id: user.role_id,
        role_name: user.role_name,
      }));
      setFilteredUsers(users);
      return users;
    } else {
      setFilteredUsers([]);
      console.error("Invalid user data format:", response);
      toast.error("Failed to load users for the selected role");
      return [];
    }
  } catch (error) {
    setFilteredUsers([]);
    console.error("Error fetching users for role:", error);
    toast.error("Failed to load users for the selected role");
    return [];
  } finally {
    setLoader(false);
  }
};
console.log(filteredUsers,"filteredusers")
  const handleUserChange = (e) => {
    const selectedUserId = e.target.value;
    setFormData({
      ...formData,
      selectedUser: selectedUserId,
    });
    setValidationErrors({
      ...validationErrors,
      selectedUser: selectedUserId ? "" : "Please select a user",
    });
  };
  // Fixed: Modified fetchAllRoles to handle comma-separated teams
const fetchAllRoles = async () => {
  try {
    const rolearr = await getData(departmentslist);
    
    if (state?.incidentData?.assignedTeam) {
      const assignedTeam = state.incidentData.assignedTeam;
      
      // Parse comma-separated string: "39,43" -> [39, 43]
      const targetRoleIds = assignedTeam
        ? assignedTeam.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id))
        : [];

      console.log("Target role IDs:", targetRoleIds); // Debug log

      // Filter roles that match any of the assigned team IDs
      const filteredRoles = rolearr.filter(role => 
        targetRoleIds.includes(role.id)
      );

      if (filteredRoles.length > 0) {
        const roleList = filteredRoles.map((role) => ({
          label: role.name,
          value: role.id,
          id: role.created_by,
        }));
        setRoleList(roleList);
        console.log("Filtered roles found:", roleList); // Debug log
      } else {
        console.log("No matching roles found, using all roles");
        // Fallback to all roles if no matches found
        const sortedRoles = rolearr.sort((a, b) => a.name > b.name ? 1 : -1);
        const roleList = sortedRoles.map((role) => ({
          label: role.name,
          value: role.id,
          id: role.created_by,
        }));
        setRoleList(roleList);
      }
    } else {
      // Default behavior when no assignedTeam
      const sortedRoles = rolearr.sort((a, b) => a.name > b.name ? 1 : -1);
      const roleList = sortedRoles.map((role) => ({
        label: role.name,
        value: role.id,
        id: role.created_by,
      }));
      setRoleList(roleList);
    }
  } catch (error) {
    console.error("Error fetching roles:", error);
    toast.error("Failed to load roles");
  }
};

  // to fetch userlist
  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        getUserList(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    if (profile.role_name === "SUPER ADMIN") {
      return {
        admin_role: "SA",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    } else if (profile.is_admin === true) {
      return {
        admin_role: "HO",
        bank_id: profile.bank_id || null,
        userId: profile.id,
      };
    }
    else {
      return {
        admin_role: "U",
        bank_id: profile.bank_id || null,
        branch_id: profile.branch_id || null,
      };
    }
  };

  const getUserList = async (profile) => {
    setLoader(true);
    try {
      const payload = createPayload(profile);
      const fetchedUsers = await postDataWithBody(getUsersFromAppByRole, payload, {});
      const sortedUsers = fetchedUsers.sort((a, b) =>
        a.first_name > b.first_name ? 1 : -1
      );
      const userList = sortedUsers.map((user) => ({
        label: `${user.first_name} ${user.last_name}`,
        value: user.id,
        created_by: user.created_by, // Make sure this field is captured
      }));
      setUserList(userList);
    } catch (error) {
      console.error("Error fetching user list:", error);
      toast.error("Failed to load user list");
    } finally {
      setLoader(false);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id);
        const user = response[0];
        setUserProfile(user);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchIncidentDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["INCDNT_CAT"],
        {}
      );
      if (response && Array.isArray(response)) {
        setIncidentCategories(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  // Upload image 
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    let validFilesCount = selectedImages.length;

    for (const file of files) {
      if (!file.type.startsWith("image/")) {
        toast.error(`"${file.name}" is not a valid image file.`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        continue;
      }

      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > 1) {
        toast.error(`"${file.name}" exceeds 1MB size limit.`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        continue;
      }

      if (validFilesCount >= 3) {
        toast.error("You can only upload up to 3 image files.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        break;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prevImages) => [
          ...prevImages,
          { file, preview: reader.result },
        ]);
      };
      reader.readAsDataURL(file);
      validFilesCount++;
    }

    e.target.value = ""; // Reset input so same files can be selected again
  };

  // Upload image  related
  const loadExistingFiles = (files) => {
    if (!files || !Array.isArray(files)) return;
    Promise.all(
      files.map(async (file) => {
        try {
          const response = await fetch(file.mediaPath);
          const blob = await response.blob();
          const fileObject = new File(
            [blob],
            `file_${file.id}.${getFileExtension(file.mediaPath)}`,
            {
              type: blob.type,
            }
          );
          return {
            file: fileObject,
            preview: file.mediaPath,
            id: file.id,
            isExisting: true,
          };
        } catch (error) {
          console.error("Error loading file:", error);
          return {
            preview: file.mediaPath,
            id: file.id,
            isExisting: true,
            error: true,
          };
        }
      })
    ).then((fileObjects) => {
      setSelectedImages((prevImages) => [
        ...prevImages,
        ...fileObjects.filter(Boolean),
      ]);
    });
  };

  const getFileExtension = (url) => {
    const filename = url.split("/").pop();
    return filename.split(".").pop();
  };

  //set selected image
  useEffect(() => {
    setSelectedImages([]);
    if (data && data.files && Array.isArray(data.files)) {
      loadExistingFiles(data.files);
    }
  }, [data]);

  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  //validations
  const validateForm = () => {
    const currentStatus = formData.status;
    if (formData.status === "InProgress") {
      return true;
    }
    const errors = {};
    // Always validate basic fields (except in certain readonly scenarios)
    if (!data) { // Adjust based on your readonly logic
      errors.slaTarget = validateslaTarget(formData.slaTarget);
      errors.eventName = validateEventName(formData.eventName);
      errors.eventType = validateEventType(formData.eventType);
      errors.sourceSystem = validateSourceSystem(formData.sourceSystem);
      errors.severity = validateSeverityLevel(formData.severity);
      errors.assignTo = validateAssignTo(formData.assignTo);
      errors.selectedUser = validateUser(formData.selectedUser);
    }

    // Status-specific validation
    if (currentStatus === "InProgress") {
      errors.resolutionStartDate = validationStartDate(formData.resolutionStartDate);
      errors.rootCause = validateRootCause(formData.rootCause);
      errors.actionTaken = validateActionTaken(formData.actionTaken);
    } else if (currentStatus === "Closed") {

      errors.resolutionEndDate = validationEndDate(formData.resolutionEndDate);
      errors.rootCause = validateRootCause(formData.rootCause);
      errors.actionTaken = validateActionTaken(formData.actionTaken);

      // Additional validation: end date should be after start date
      if (formData.resolutionStartDate && formData.resolutionEndDate) {
        const startDate = new Date(formData.resolutionStartDate);
        const endDate = new Date(formData.resolutionEndDate);
        if (endDate <= startDate) {
          errors.resolutionEndDate = "Resolution End Date must be after Start Date";
        }
      }
    }

    setValidationErrors(errors);

    // Debug logging
    Object.entries(errors).forEach(([field, error]) => {
      if (error !== "") {
        console.log(`Validation failed for ${field}: ${error}`);
      }
    });

    return !Object.values(errors).some((error) => error !== "");
  };

  //submit event
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    if (formData.status === "InProgress") {
      await handleStatusChange({ target: { value: "InProgress" } });
      return;
    } else if (formData.status === "Closed") {
      setIsSubmitting(true);
      setLoader(true);
      try {
        const ID = data?.eventIncidentMapEntity?.id;
        const assignedUserId = parseInt(
          formData.selectedUser || data?.assignedToUser || 271,
          10
        );
        const eventMapValue = {
          id: ID,
          updated_by: assignedUserId,
          resoultionEndDateAndTimeString: formatDateTime(formData.resolutionEndDate),
          rootCause: formData.rootCause || "network issue",
          actionTakenCompleted:
            formData.actionTaken || "Solved the net cabel issue",
        };
        const formDataPayload = new FormData();
        formDataPayload.append("event_map", JSON.stringify(eventMapValue));

        // Add images to the payload or empty blob if no images
        if (selectedImages.length > 0) {
          selectedImages.forEach((imgObj) => {
            if (!imgObj.isExisting) {
              formDataPayload.append("files", imgObj.file);
            }
          });
        } else {
          // Append empty blob when no images are selected
          formDataPayload.append("files", new Blob(), 'empty.txt');
        }

        console.log("Updating event to Closed:", eventMapValue);
        const response = await postDataWithFiles(
          editEventClosed,
          formDataPayload
        );
        if (response && response.status === "success") {
          toast.success("Event status updated to Closed", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          navigate("../event-type-details");
        } else {
          toast.error(response?.msg || "Failed to update event status", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error("Error updating event status to Closed:", error);
        toast.error("An error occurred while updating event status", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } finally {
        setLoader(false);
        setIsSubmitting(false);
      }
      return;
    }

    setIsSubmitting(true);
    setLoader(true);
    try {
      let incidentDateAndTimeString = "";
      if (state?.incidentData?.eventOccurred) {
        const dateStr = state.incidentData.eventOccurred;
        if (dateStr.includes("/")) {
          const [datePart, timePart, meridiem] = dateStr.split(" ");
          const [day, month, year] = datePart.split("/");
          incidentDateAndTimeString = `${day}-${month}-${year} ${timePart} ${meridiem}`;
        } else if (dateStr.includes("-")) {
          if (dateStr.endsWith("AM") || dateStr.endsWith("PM")) {
            incidentDateAndTimeString = dateStr;
          } else {
            const hour = parseInt(dateStr.split(" ")[1].split(":")[0], 10);
            const meridiem = hour >= 12 ? "PM" : "AM";
            incidentDateAndTimeString = `${dateStr} ${meridiem}`;
          }
        }
      } else if (formData.eventOccurred) {
        const dateStr = formData.eventOccurred;
        if (dateStr.includes("/")) {
          const parts = dateStr.split(" ");
          const datePart = parts[0];
          const timePart = parts[1];
          const meridiem = parts[2] || ""; // This might be AM/PM or empty
          const [day, month, year] = datePart.split("/");
          if (meridiem === "AM" || meridiem === "PM") {
            incidentDateAndTimeString = `${day}-${month}-${year} ${timePart} ${meridiem}`;
          } else {
            const hour = parseInt(timePart.split(":")[0], 10);
            const newMeridiem = hour >= 12 ? "PM" : "AM";
            incidentDateAndTimeString = `${day}-${month}-${year} ${timePart} ${newMeridiem}`;
          }
        } else if (dateStr.includes("-")) {
          const parts = dateStr.split(" ");
          if (parts.length > 2 && (parts[2] === "AM" || parts[2] === "PM")) {
            incidentDateAndTimeString = dateStr;
          } else {
            const hour = parseInt(parts[1].split(":")[0], 10);
            const meridiem = hour >= 12 ? "PM" : "AM";
            incidentDateAndTimeString = `${dateStr} ${meridiem}`;
          }
        }
      }
      if (
        !incidentDateAndTimeString ||
        !incidentDateAndTimeString.includes("-")
      ) {
        const now = new Date();
        const formattedDate = now
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .replace(/\//g, "-");
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const formattedTime = `${hours % 12 || 12}:${minutes
          .toString()
          .padStart(2, "0")}`;
        const meridiem = hours >= 12 ? "PM" : "AM";
        incidentDateAndTimeString = `${formattedDate} ${formattedTime} ${meridiem}`;
      }
      const selectedEventType = eventType.find(
        (type) => type.value === formData.eventType
      );
      const eventTypeId = selectedEventType ? selectedEventType.id : null;
      const selectedUserId = parseInt(
        formData.selectedUser || formData.assignTo,
        10
      );
      const selectedRoleValue = formData.assignTo;
      const eventPayload = {
        incidentId: incidentData?.id,
        incidentCategoryId: incidentData?.incidentCategoryId,
        incidentDateAndTimeString: incidentDateAndTimeString, // Now correctly formatted with AM/PM
        severityLevel: formData.severity,
        eventName: formData.eventName,
        eventSubCategoryId: eventTypeId,
        sourceSystem: formData.sourceSystem,
        assignedTeam:
          parseInt(selectedRoleValue) || state?.incidentData?.assignedTeam,
        assignedToUser: selectedUserId,
        created_by: userId,
        slaTarget: formData.slaTarget,
        description: formData.eventDescription || "description",
        is_deleted: false,
      };
      console.log("Submitting event payload:", eventPayload);
      console.log("Number of images being uploaded:", selectedImages.length);
      const formDataToSend = new FormData();
      formDataToSend.append("event", JSON.stringify(eventPayload));

      // Add images to the payload or empty blob if no images
      if (selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          formDataToSend.append("files", imgObj.file);
        });
      } else {
        // Append empty blob when no images are selected
        formDataToSend.append("files", new Blob(), 'empty.txt');
      }

      const response = await postDataWithFiles(createEvent, formDataToSend);
      if (response.status === "success") {
        toast.success("Event created successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate("../event-type-details");
      } else {
        toast.error(response.msg || "Failed to create event", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
      setIsSubmitting(false);
    }
  };

  // Fixed: Enhanced useEffect for form data initialization with comma-separated teams
useEffect(() => {
  if (state?.incidentData) {
    const incident = state.incidentData;
    const assignedTeam = incident.assignedTeam;
    
    // Parse comma-separated assignedTeam: "39,43" -> [39, 43]
    let assignedTeamIds = [];
    let matchingRole;
    
    if (assignedTeam && typeof assignedTeam === 'string') {
      assignedTeamIds = assignedTeam
        .split(',')
        .map(id => parseInt(id.trim(), 10))
        .filter(id => !isNaN(id));
      
      console.log("Parsed assignedTeam IDs:", assignedTeamIds);
      
      // Try to find a matching role for any of the team IDs
      matchingRole = roleList.find(role => 
        assignedTeamIds.some(teamId => parseInt(role.value, 10) === teamId)
      );
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      incidentName: incident.incidentName || "",
      eventOccurred: incident.eventOccurred || 
                     formatDateTime(incident.incidentDateAndTime) || "",
      sourceSystem: incident.sourceSystem || "",
      severity: incident.severityLevel || "",
      assignTo: "", // Keep empty to show "Choose team"
    }));

    if (incident.latitude && incident.longitude) {
      setCoordinates([{
        y: incident.longitude,
        x: incident.latitude,
      }]);
    }
  } else if (data) {
    setFormData({
      ...formData,
      ...data,
    });
    if (data.latitude && data.longitude) {
      setCoordinates([{
        y: data.longitude,
        x: data.latitude,
      }]);
    }
  }
}, [state, data, roleList]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "NA";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.error("Invalid date input:", dateString);
        return "NA";
      }
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // Convert 0 to 12
      const formattedTime = `${hours
        .toString()
        .padStart(2, "0")}:${minutes} ${ampm}`;
      return `${day}-${month}-${year} ${formattedTime}`;
    } catch (error) {
      console.error("Date formatting error:", error);
      return "NA";
    }
  };

  return (
    <>
      <div className="main-container mt-4">
        {data ? (
          <>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="eventName" className="form-label">
                  Event Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventName ? "is-invalid" : ""
                    }`}
                  id="eventName"
                  value={formData.eventName}
                  onChange={handleInputChange}
                  readOnly
                />
                {validationErrors.eventName && (
                  <div className="invalid-feedback">
                    {validationErrors.eventName}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="eventType" className="form-label">
                  Event Type<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventName ? "is-invalid" : ""
                    }`}
                  id="eventName"
                  value={
                    // localStorage.getItem("incidentCategoryName") ||
                    formData.eventType || ""
                  }
                  onChange={handleInputChange}
                  readOnly
                />
                {validationErrors.eventType && (
                  <div className="invalid-feedback">
                    {validationErrors.eventType}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="incidentDateAndTime" className="form-label">
                  Incident Date & Time
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.incidentDateAndTime ? "is-invalid" : ""
                    }`}
                  id="incidentDateAndTime"
                  value={
                    formData.incidentDateAndTime
                      ? formatDateTime(formData.incidentDateAndTime)
                      : ""
                  }
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="severityLevel" className="form-label">
                  Severity<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.severityLevel ? "is-invalid" : ""
                    }`}
                  id="severityLevel"
                  value={formData.severityLevel}
                  onChange={handleInputChange}
                  readOnly
                />
                {validationErrors.severity && (
                  <div className="invalid-feedback">
                    {validationErrors.severity}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="description" className="form-label">
                  Event Description
                </label>
                <textarea
                  className={`form-control branch-input-form-control ${validationErrors.description ? "is-invalid" : ""
                    }`}
                  id="description"
                  rows="2"
                  maxLength="250"
                  value={formData.description}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-3">
                <label htmlFor="resolutionStartDate" className="form-label">
                  Resolution Start Date & Time
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control ${validationErrors.resolutionStartDate ? "is-invalid date-icon-left" : ""
                    }`}
                  id="resolutionStartDate"
                  value={
                    eventData.event_status === 750
                      ? ""
                      : formData.resolutionStartDate
                  }
                  onChange={handleInputChange}
                  disabled={eventData?.event_status === 750}
                />
                {validationErrors.resolutionStartDate && (
                  <div className="invalid-feedback">
                    {validationErrors.resolutionStartDate}
                  </div>
                )}
              </div>
              <div className="col-md-3">
                <label htmlFor="resolutionEndDate" className="form-label">
                  Resolution End Date & Time
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control  ${validationErrors.resolutionEndDate ? "is-invalid date-icon-left" : ""
                    }`}
                  id="resolutionEndDate"
                  value={formData.resolutionEndDate}
                  onChange={handleInputChange}
                  disabled={eventData?.event_status === 749}
                />
                {validationErrors.resolutionEndDate && (
                  <div className="invalid-feedback">
                    {validationErrors.resolutionEndDate}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="status" className="form-label">
                  Status<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.status ? "is-invalid" : ""
                    }`}
                  id="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Select Status
                  </option>
                  <option
                    value="Open"
                    disabled={
                      eventData?.event_status === 750 ||
                      eventData?.event_status === 752
                    }
                  >
                    Open
                  </option>
                  <option
                    value="InProgress"
                    disabled={eventData?.event_status === 752}
                  >
                    In Progress
                  </option>
                  <option
                    value="Closed"
                    disabled={eventData?.event_status === 749}
                  >
                    Closed
                  </option>
                  {/* <option value="Hold">Hold</option> */}
                </select>
                {validationErrors.status && (
                  <div className="invalid-feedback">
                    {validationErrors.status}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="rootCause" className="form-label">
                  Root Cause <span className="text-danger">*</span>
                </label>
                <textarea
                  className={`form-control branch-input-form-control ${validationErrors.rootCause ? "is-invalid" : ""
                    }`}
                  id="rootCause"
                  name="rootCause"
                  rows="2"
                  maxLength="250"
                  value={formData.rootCause}
                  onChange={handleInputChange}
                />
                {validationErrors.rootCause && (
                  <div className="invalid-feedback">
                    {validationErrors.rootCause}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="actionTaken" className="form-label">
                  Action Taken <span className="text-danger">*</span>
                </label>
                <textarea
                  className={`form-control branch-input-form-control ${validationErrors.actionTaken ? "is-invalid" : ""
                    }`}
                  id="actionTaken"
                  rows="2"
                  maxLength="250"
                  name="actionTaken"
                  value={formData.actionTaken || ""} // Add the || "" to ensure it's never undefined
                  onChange={handleInputChange}
                />
                {validationErrors.actionTaken && (
                  <div className="invalid-feedback">
                    {validationErrors.actionTaken}
                  </div>
                )}
              </div>
            </div>
            {formData.status === "Closed" && (
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="attachments" className="form-label">
                    Upload Images
                  </label>
                  <input
                    type="file"
                    className="form-control branch-input-form-control"
                    id="attachments"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleImageChange}
                    multiple
                  />
                  <div className="mt-3 d-flex flex-wrap">
                    {selectedImages.map((imgObj, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          margin: "5px",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={imgObj.preview}
                          alt={`preview-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "4px",
                          }}
                        />
                        <button
                          onClick={() => removeImage(index)}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            color: "black",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Remove image"
                        >
                          ✖
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="incidentName" className="form-label">
                  Incident Name
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.incidentName ? "is-invalid" : ""
                    }`}
                  id="incidentName"
                  value={formData.incidentName}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="eventOccurred" className="form-label">
                  Incident Date & Time
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventOccurred ? "is-invalid" : ""
                    }`}
                  id="eventOccurred"
                  value={formData.eventOccurred}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="eventName" className="form-label">
                  Event Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventName ? "is-invalid" : ""
                    }`}
                  id="eventName"
                  value={formData.eventName}
                  onChange={handleInputChange}
                />
                {validationErrors.eventName && (
                  <div className="invalid-feedback">
                    {validationErrors.eventName}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="eventType" className="form-label">
                  Event Type<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.eventType ? "is-invalid" : ""
                    }`}
                  id="eventType"
                  value={formData.eventType}
                  onChange={handleEventTypeChange} // Use the new handler
                >
                  <option value="" disabled>
                    Select event type
                  </option>
                  {eventType.map((type) => (
                    <option key={type.id} value={type.value}>
                      {type.value}
                    </option>
                  ))}
                </select>
                {validationErrors.eventType && (
                  <div className="invalid-feedback">
                    {validationErrors.eventType}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="sourceSystem" className="form-label">
                  Source System<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.sourceSystem ? "is-invalid" : ""
                    }`}
                  id="sourceSystem"
                  value={formData.sourceSystem}
                  onChange={handleInputChange}
                />
                {validationErrors.sourceSystem && (
                  <div className="invalid-feedback">
                    {validationErrors.sourceSystem}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="severity" className="form-label">
                  Severity<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.severity ? "is-invalid" : ""
                    }`}
                  id="severity"
                  value={formData.severity}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Select severity level
                  </option>
                  <option value="Critical">Critical</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
                {validationErrors.severity && (
                  <div className="invalid-feedback">
                    {validationErrors.severity}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="assignTo" className="form-label">
                  Assign To<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.assignTo ? "is-invalid" : ""
                    }`}
                  id="assignTo"
                  value={formData.assignTo}
                  onChange={handleRoleChange}
                >
                  <option value="" disabled>
                    Choose team
                  </option>
                  {roleList.map((team) => (
                    <option key={team.value} value={team.value}>
                      {team.label}
                    </option>
                  ))}
                </select>
                {validationErrors.assignTo && (
                  <div className="invalid-feedback">
                    {validationErrors.assignTo}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="selectedUser" className="form-label">
                  Select User<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.selectedUser ? "is-invalid" : ""
                    }`}
                  id="selectedUser"
                  value={formData.selectedUser || ""}
                  onChange={handleUserChange}
                >
                  <option value="" disabled>
                    Choose user
                  </option>
                  {filteredUsers.map((user) => (
                    <option key={user.value} value={user.value}>
                      {user.label}
                    </option>
                  ))}
                </select>
                {validationErrors.selectedUser && (
                  <div className="invalid-feedback">
                    {validationErrors.selectedUser}
                  </div>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="slaTarget" className="form-label">
                  SLA Target<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.slaTarget ? "is-invalid" : ""
                    }`}
                  id="slaTarget"
                  name="slaTarget"
                  value={formData.slaTarget}
                  onChange={handleInputChange}
                />
                {validationErrors.slaTarget && (
                  <div className="invalid-feedback">
                    {validationErrors.slaTarget}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="eventDescription" className="form-label">
                  Event Description
                </label>
                <textarea
                  className={`form-control branch-input-form-control ${validationErrors.eventDescription ? "is-invalid" : ""
                    }`}
                  id="eventDescription"
                  rows="5"
                  maxLength="250"
                  value={formData.eventDescription}
                  onChange={handleInputChange}
                />
                <small className="text-muted">Maximum 250 characters</small>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6" style={{ marginTop: "-6.2rem" }}>
                <label htmlFor="attachments" className="form-label">
                  Upload Images
                </label>
                <input
                  type="file"
                  className="form-control branch-input-form-control"
                  id="attachments"
                  accept=".jpg, .jpeg, .png"
                  onChange={handleImageChange}
                  multiple
                />
                <div className="mt-3 d-flex flex-wrap">
                  {selectedImages.map((imgObj, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        margin: "5px",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={imgObj.preview}
                        alt={`preview-${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                      />
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          color: "black",
                          border: "none",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        title="Remove image"
                      >
                        ✖
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {eventData?.event_status === 750 ?
        <div className="d-flex justify-content-center">
          <div className="d-flex justify-content-center">
            <button
              className="branch-save-submit-btn btn btn-success"
              onClick={handleSubmit}
              disabled={
                isSubmitting ||
                isTextFieldDisable ||
                ((eventData?.event_status === 749 ||
                  eventData?.event_status === 750) &&
                  formData.status !== "Closed" &&
                  formData.status !== "InProgress") || formData.status === 'InProgress'
              }
            >
              {isSubmitting ? "Submitting..." : data ? "Update" : "Save & Submit"}
            </button>
          </div>
        </div>
        : <div className="d-flex justify-content-center">
          <div className="d-flex justify-content-center">
            <button
              className="branch-save-submit-btn btn btn-success"
              onClick={handleSubmit}
              disabled={
                isSubmitting ||
                isTextFieldDisable ||
                ((eventData?.event_status === 749 ||
                  eventData?.event_status === 750) &&
                  formData.status !== "Closed" &&
                  formData.status !== "InProgress")
              }
            >
              {isSubmitting ? "Submitting..." : data ? "Update" : "Save & Submit"}
            </button>
          </div>
        </div>}
      {loader && (
        <div className="loader-container">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {showMapModal && (
        <Modal
          className="modal-position"
          size="lg"
          show={showMapModal}
          onHide={closeMapModal}
          aria-labelledby="example-modal-sizes-title-lg"
          right
        >
          <Modal.Header>
            <Modal.Title
              id="example-modal-sizes-title-lg"
              style={{ color: "#001b30", marginRight: "500px" }}
            >
              {"Choose Location"}
            </Modal.Title>
            <XCircleblack
              className="cursor-pointer"
              onClick={closeMapModal}
              width="1.5em"
              height="1.5em"
              style={{ color: "#001b30" }}
            />
          </Modal.Header>
          <Modal.Body>
            <div className="gis-mapcontainer">
              <LocationAutoComplete updateMapLocation={updateMapLocation} />
            </div>
          </Modal.Body>
        </Modal>
      )}
      <ToastContainer />
    </>
  );
};
export default CreateEventForm;
